import { gql } from '@apollo/client';

export type {
  GetSessionData as IGetSessionData,
  GetSessionData_session_human as ISessionHuman,
} from './__generated__/GetSessionData';

export const GET_SESSION_DATA = gql`
  query GetSessionData {
    session {
      human {
        email
        first_name
        full_name
        has_resale_closing_dashboard
        has_partnership_referral_dashboard
        has_partnership_reporting_dashboard
        has_partnership_developer_dashboard
        id
      }
      logged_in
    }
  }
`;
